import { Box, Button, Typography } from '@mui/material';
import React, { MouseEvent } from 'react';
import { useRespondToRsvpMutation } from '../../../../app/Slices/SevenDayApiSlice';
import toast from '../../../shared/Toast';
import { BookingAttendee, RsvpStatus } from '../../../types/reservation';
import { capitalizeName } from '../../../../shared/utils';

export default ({
    bookingId,
    attendee: {
        rsvp: { id, status },
    },
    isApproved,
}: {
    bookingId: number;
    attendee: BookingAttendee;
    isApproved: boolean;
}) => {
    const [respondToRsvp] = useRespondToRsvpMutation();

    const handleRespond = async (
        e: MouseEvent<HTMLButtonElement>,
        id: string,
        status: RsvpStatus,
    ) => {
        try {
            e.stopPropagation();
            await respondToRsvp({
                bookingId,
                rsvpId: id,
                status,
            }).unwrap();

            toast.success(`RSVP request ${status} successfully.`);
        } catch {
            toast.error('Error responding to RSVP request.');
        }
    };
    return (
        <Box sx={{ p: 2.25 }}>
            <Box sx={{ mt: 1.75 }}>
                <Box sx={{ display: 'grid', gap: 1 }}>
                    <Typography
                        component='h2'
                        variant='body1'
                        sx={{
                            fontWeight: 900,
                            letterSpacing: 0.2,
                            fontSize: 15,
                            lineHeight: 1.15,
                        }}
                    >
                        RSVP
                    </Typography>
                    {capitalizeName(status)}
                    {['pending', 'declined'].includes(status) && (
                        <Button
                            variant='contained'
                            color='primary'
                            sx={{
                                borderRadius: 2,
                                height: 34,
                                textTransform: 'none' as const,
                                whiteSpace: 'nowrap' as const,
                            }}
                            disabled={!isApproved}
                            onClick={(e: MouseEvent<HTMLButtonElement>) =>
                                handleRespond(e, id, 'accepted')
                            }
                        >
                            Accept
                        </Button>
                    )}
                    {['pending', 'accepted'].includes(status) && (
                        <Button
                            variant='contained'
                            color='error'
                            disabled={!isApproved}
                            sx={{
                                borderRadius: 2,
                                height: 34,
                                textTransform: 'none' as const,
                                whiteSpace: 'nowrap' as const,
                            }}
                            onClick={(e: MouseEvent<HTMLButtonElement>) =>
                                handleRespond(e, id, 'declined')
                            }
                        >
                            Decline
                        </Button>
                    )}
                </Box>
            </Box>
        </Box>
    );
};
